import StrikeZoneModelBase from '../classificators/strikeZoneModel/StrikeZoneModelBase.js';
import { Series } from '../entities/index.js';

const strikeZoneSectorsGridSeriesProvider = function(strikeZoneModel, fromPitchersPerspective) {
    if (!(strikeZoneModel instanceof StrikeZoneModelBase)){
        throw new TypeError('strikeZoneModel must extend StrikeZoneModelBase');
    }

    const left = strikeZoneModel.getStrikeZoneLeft();
    const right = strikeZoneModel.getStrikeZoneRight();
    const top = strikeZoneModel.getStrikeZoneTop();
    const bottom = strikeZoneModel.getStrikeZoneBottom();

    const verticalCenter = bottom + (top - bottom) / 2;
    const horizontalCenter = (left + right) / 2;
    const verticalThird = Math.abs(top - bottom) / 3;
    const horizontalThird = Math.abs(left - right) / 3;

    const sectors = new Series('strikeZoneSectors', 2);
    const xMultiplier = fromPitchersPerspective ? -1: 1;

    // outer sectors, leave it half open, each is 1/2 of height/width
    sectors.add(undefined, 
        xMultiplier * (left - strikeZoneModel.maxHorizontalOffset),
        verticalCenter
    );
    sectors.add(undefined, 
        xMultiplier * left,
        verticalCenter
    );
    sectors.add(undefined, 
        xMultiplier * left,
        top
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        top
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        top + strikeZoneModel.maxVerticalOffset
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        top
    );
    sectors.add(undefined, 
        xMultiplier * right,
        top
    );
    sectors.add(undefined, 
        xMultiplier * right,
        verticalCenter
    );
    sectors.add(undefined, 
        xMultiplier * (right + strikeZoneModel.maxHorizontalOffset),
        verticalCenter
    );
    sectors.add(undefined, 
        xMultiplier * right,
        verticalCenter
    );
    sectors.add(undefined, 
        xMultiplier * right,
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        bottom - strikeZoneModel.maxVerticalOffset
    );
    sectors.add(undefined, 
        xMultiplier * horizontalCenter,
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * left,
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * left,
        verticalCenter
    );
    // inner grid
    sectors.add(undefined, 
        xMultiplier * left,
        top - verticalThird
    );
    sectors.add(undefined, 
        xMultiplier * right,
        top - verticalThird
    );
    sectors.add(undefined, 
        xMultiplier * right,
        top - 2 * verticalThird
    );
    sectors.add(undefined, 
        xMultiplier * left,
        top - 2 * verticalThird
    );
    sectors.add(undefined, 
        xMultiplier * left,
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * (left + horizontalThird),
        bottom
    );
    sectors.add(undefined, 
        xMultiplier * (left + horizontalThird),
        top
    );
    sectors.add(undefined, 
        xMultiplier * (left + 2 * horizontalThird),
        top
    );
    sectors.add(undefined, 
        xMultiplier * (left + 2 * horizontalThird),
        bottom
    );

    return sectors;
};

export default strikeZoneSectorsGridSeriesProvider;